import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineSearch, HiOutlineGlobeAlt } from "react-icons/hi";

const Header: React.FC = () => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate("/scandinavian-airlines");
    };

    return (
        <header className="fixed top-0 left-60 right-0 max-h-[72px] h-full bg-white z-30 flex items-center justify-between px-3 shadow-md">
            <div className="flex items-center px-2 focus:outline-dashed">
                <button onClick={handleLogoClick} className="flex items-center">
                    <img src="/SAS.svg" alt="SAS" className="h-9 w-auto" />
                </button>
            </div>

            <div className="flex items-center gap-2">
                <button className="p-2 hover:bg-sas-gray rounded-full transition-colors">
                    {React.createElement(HiOutlineSearch as any, {
                        className: "text-xl text-sas-blue-dark",
                    })}
                </button>
                <button className="p-2 hover:bg-sas-gray rounded-full transition-colors">
                    {React.createElement(HiOutlineGlobeAlt as any, {
                        className: "text-xl text-sas-blue-dark",
                    })}
                </button>
                <button className="px-6 py-2 text-sas-blue-dark border-2 border-sas-blue-dark rounded-full font-medium hover:bg-sas-blue-dark hover:text-white transition-colors cursor-pointer">
                    Log in
                </button>
            </div>
        </header>
    );
};

export default Header;
